import ChartCardLoading from './chartCard.component';

export default ChartCardLoading;